<ep-sub-panel blockWidth="full" panelType="transparent" [form]="form">
  <form [formGroup]="form">
    <ep-field
      label="File Only"
      format="checkbox-YN"
      hideLabel="true"
      columnSpan="45px"
      collapseLabelArea="true"
      controlPath="Filing.File_Only_Ind"
    ></ep-field>
    <ep-field format="container" columnSpan="190px" collapseLabelArea="true">
      <div style="vertical-align: middle">
        <b style="font-size: 15px">
          {{ this.form.getRawValue().Filing.Entity.Entity_Name }} ({{
            this.form.getRawValue().Filing.Entity.Role_Type | epRoleType
          }})
        </b>
      </div>
    </ep-field>

    <ep-field
      label="Attention"
      format="search-entity"
      hideLabel="true"
      columnSpan="190px"
      collapseLabelArea="true"
      [options]="{ autoSearch: true, allowClear: true }"
      [criteria]="{
        Role_Type: this.getControlValue('Filing.Entity.Role_Type') + '-A',
        Entity_ID: this.getControlValue('Filing.Entity.Entity_ID')
      }"
      controlPath="Filing.Affiliate.Entity_ID"
      descControlPath="Filing.Affiliate.Entity_Name"
      (dataSelected)="onAffiliateSelected($event)"
    ></ep-field>

    <ep-field
      label="File Document as Public"
      format="checkbox-YN"
      hideLabel="true"
      columnSpan="25px"
      collapseLabelArea="true"
      controlPath="Filing.Public_Document_Ind"
    ></ep-field>
    <ep-field
      label="File Document Externally"
      format="checkbox-YN"
      hideLabel="true"
      columnSpan="25px"
      collapseLabelArea="true"
      controlPath="Filing.File_External_Ind"
    ></ep-field>

    <ep-field
      label="Drawer"
      format="dropdownSelector-FileDrawer"
      hideLabel="true"
      columnSpan="100px"
      collapseLabelArea="true"
      controlPath="Filing.File_Drawer"
    ></ep-field>
    <ep-field
      label="Folder"
      format="dropdownSelector-FileFolder"
      hideLabel="true"
      columnSpan="100px"
      collapseLabelArea="true"
      controlPath="Filing.File_Folder"
    ></ep-field>
    <ep-field label="Remove" format="container" hideLabel="true" columnSpan="25px" collapseLabelArea="true">
      <div style="vertical-align: middle">
        <aurora-icon icon="trash" (click)="removeFiling()"></aurora-icon>
      </div>
    </ep-field>
  </form>
</ep-sub-panel>
